import protectedWebApi from "./protected-web-api";

export default {
    b2c: {
        scopes: [
            ...protectedWebApi.b2c.apiInsights.apiReports.scopes,
        ]
    }
}